// extracted by mini-css-extract-plugin
module.exports = {"SmallSectionTitle":"Podcast_SmallSectionTitle__c_FCW","ListenNow":"Podcast_ListenNow__a2MzR"};